import { SensorStatusModel } from './../models/sensor-status.model';
import { Injectable } from '@angular/core';
import { BaseAPI } from './baseAPI';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import {
  BACKEND_KEYS,
  BACKEND_METHOD_CONSTANT,
  BACKEND_METHOD_TYPES,
} from './url-constant';
import { SensorModel } from '../models/sensor.model';
import { BaseModel } from '../models/base.model';
import { AuthService } from './auth.service';
import { SensorMessageModel } from '../models/sensor-message.model';
import { SensorReportModel } from '../models/sensor-report.model';
import { map } from 'rxjs/operators';
import { GsmSensorReportModel } from '../models/gsm-sensor-report.model';
import { BtsModel } from '../models/bts.model';
import { GsmSensorModel } from '../models/gsm-sensor-model';
import { SiteModel } from '../models/site.model';
import { GsmConfigurationModel } from '../models/gsm-configuration.model';
import { DistributorSensorModel } from '../models/distributorSensor.model';
import { object } from 'underscore';
import { SensorRemoteCommandModel } from '../models/sensor-remote-command.model';

@Injectable()
export class SensorsService extends BaseAPI {
  constructor(public http: HttpClient, public authService: AuthService) {
    super(http, authService);
  }

  createSensor(sensor: SensorModel): Observable<SensorModel> {
    const httpParams = this.getBaseHttpParamsWithoutPlatform();

    const url = BACKEND_METHOD_CONSTANT.sensor + BACKEND_METHOD_TYPES.create;

    return this.post(url, httpParams, sensor)
      .pipe(
        map((newsensor: SensorModel) => {
          return newsensor ? newsensor : undefined;
        })
      )
      .catch(this.handleError);
  }

  // getCaptivePortalJson(sensorId: number): Observable<any> {
  //   const cmd = 'java -jar captiveportaljson_v1.0.1.jar';
  //   const httpParams = new HttpParams()
  //   .set(BACKEND_KEYS.user, this.authService.user.username)
  //   .set(BACKEND_KEYS.pass, this.authService.user.password)
  //   .set(BACKEND_KEYS.sensorId, sensorId.toString())
  //   .set(BACKEND_KEYS.shellCommand, cmd);
  // const url =
  //   BACKEND_METHOD_CONSTANT.sensor + BACKEND_METHOD_TYPES.remoteCommand;

  // return this.post(url, httpParams, sensorId)
  //   .pipe(
  //     map((newsensor: SensorModel) => {
  //       return newsensor ? newsensor : undefined;
  //     })
  //   )
  //   .catch(this.handleError);
  // }

  // getSsid(sensorId: number): Observable<any> {
  //   const cmd = 'sudo lcp_cli get ssid';
  //   const httpParams = new HttpParams()
  //     .set(BACKEND_KEYS.user, this.authService.user.username)
  //     .set(BACKEND_KEYS.pass, this.authService.user.password)
  //     .set(BACKEND_KEYS.sensorId, sensorId.toString())
  //     .set(BACKEND_KEYS.shellCommand, cmd);
  //   const url =
  //     BACKEND_METHOD_CONSTANT.sensor + BACKEND_METHOD_TYPES.remoteCommand;

  //   return this.get(url, httpParams)
  //     .pipe(
  //       map((newsensor: any) => {
  //         return newsensor ? newsensor : undefined;
  //       })
  //     )
  //     .catch(this.handleError);
  // }
  // setSsid(sensorId: number, ssid: string): Observable<SensorModel> {
  //   const httpParams = new HttpParams()
  //     .set(BACKEND_KEYS.user, this.authService.user.username)
  //     .set(BACKEND_KEYS.pass, this.authService.user.password)
  //     .set(BACKEND_KEYS.sensorId, sensorId.toString())
  //     .set(
  //       BACKEND_KEYS.shellCommand,
  //       'sudo lcp_cli set ssid ' + JSON.stringify(ssid)
  //     );
  //   const url =
  //     BACKEND_METHOD_CONSTANT.sensor + BACKEND_METHOD_TYPES.remoteCommand;

  //   return this.post(url, httpParams, sensorId)
  //     .pipe(
  //       map((newsensor: SensorModel) => {
  //         return newsensor ? newsensor : undefined;
  //       })
  //     )
  //     .catch(this.handleError);
  // }

  // ****Genenal remote command api call***********
  baseExecutedCommand(
    sensorId: number,
    shellCommand: string
  ): Observable<SensorModel> {
    const httpParams = new HttpParams()
      .set(BACKEND_KEYS.user, this.authService.user.username)
      .set(BACKEND_KEYS.pass, this.authService.user.password)
      .set(BACKEND_KEYS.sensorId, sensorId.toString())
      .set(BACKEND_KEYS.shellCommand, shellCommand);
    const url =
      BACKEND_METHOD_CONSTANT.sensor + BACKEND_METHOD_TYPES.remoteCommand;

    return this.post(url, httpParams, sensorId)
      .pipe(
        map((newsensor: SensorModel) => {
          return newsensor ? newsensor : undefined;
        })
      )
      .catch(this.handleError);
  }

  getRedirectUrl(sensorId: number): Observable<SensorModel> {
    const httpParams = new HttpParams()
      .set(BACKEND_KEYS.user, this.authService.user.username)
      .set(BACKEND_KEYS.pass, this.authService.user.password)
      .set(BACKEND_KEYS.sensorId, sensorId.toString())
      .set(BACKEND_KEYS.shellCommand, 'sudo lcp_cli get redirect_url');
    const url =
      BACKEND_METHOD_CONSTANT.sensor + BACKEND_METHOD_TYPES.remoteCommand;

    return this.get(url, httpParams)
      .pipe(
        map((newsensor: SensorModel) => {
          return newsensor ? newsensor : undefined;
        })
      )
      .catch(this.handleError);
  }
  setRedirectUrl(sensorId: number): Observable<SensorModel> {
    const httpParams = new HttpParams()
      .set(BACKEND_KEYS.user, this.authService.user.username)
      .set(BACKEND_KEYS.pass, this.authService.user.password)
      .set(BACKEND_KEYS.sensorId, sensorId.toString())
      .set(BACKEND_KEYS.shellCommand, 'sudo lcp_cli set redirect_url');
    const url =
      BACKEND_METHOD_CONSTANT.sensor + BACKEND_METHOD_TYPES.remoteCommand;

    return this.post(url, httpParams, sensorId)
      .pipe(
        map((newsensor: SensorModel) => {
          return newsensor ? newsensor : undefined;
        })
      )
      .catch(this.handleError);
  }

  getAutoDisconnect(sensorId: number): Observable<SensorModel> {
    const httpParams = new HttpParams()
      .set(BACKEND_KEYS.user, this.authService.user.username)
      .set(BACKEND_KEYS.pass, this.authService.user.password)
      .set(BACKEND_KEYS.sensorId, sensorId.toString())
      .set(BACKEND_KEYS.shellCommand, 'lcp_cli get auto_disconnect');
    const url =
      BACKEND_METHOD_CONSTANT.sensor + BACKEND_METHOD_TYPES.remoteCommand;

    return this.get(url, httpParams)
      .pipe(
        map((newsensor: SensorModel) => {
          return newsensor ? newsensor : undefined;
        })
      )
      .catch(this.handleError);
  }

  setAutoDisconnect(sensorId: number, value: boolean): Observable<SensorModel> {
    const httpParams = new HttpParams()
      .set(BACKEND_KEYS.user, this.authService.user.username)
      .set(BACKEND_KEYS.pass, this.authService.user.password)
      .set(BACKEND_KEYS.sensorId, sensorId.toString())
      .set(
        BACKEND_KEYS.shellCommand,
        'sudo lcp_cli set auto_disconnect ' + value
      );
    const url =
      BACKEND_METHOD_CONSTANT.sensor + BACKEND_METHOD_TYPES.remoteCommand;

    return this.post(url, httpParams, sensorId)
      .pipe(
        map((newsensor: SensorModel) => {
          return newsensor ? newsensor : undefined;
        })
      )
      .catch(this.handleError);
  }

  getChannel(sensorId: number): Observable<SensorModel> {
    const httpParams = new HttpParams()
      .set(BACKEND_KEYS.user, this.authService.user.username)
      .set(BACKEND_KEYS.pass, this.authService.user.password)
      .set(BACKEND_KEYS.sensorId, sensorId.toString())
      .set(BACKEND_KEYS.shellCommand, 'lcp_cli get channel');
    const url =
      BACKEND_METHOD_CONSTANT.sensor + BACKEND_METHOD_TYPES.remoteCommand;

    return this.get(url, httpParams)
      .pipe(
        map((newsensor: SensorModel) => {
          return newsensor ? newsensor : undefined;
        })
      )
      .catch(this.handleError);
  }

  setChannel(sensorId: number, value: number): Observable<SensorModel> {
    const httpParams = new HttpParams()
      .set(BACKEND_KEYS.user, this.authService.user.username)
      .set(BACKEND_KEYS.pass, this.authService.user.password)
      .set(BACKEND_KEYS.sensorId, sensorId.toString())
      .set(BACKEND_KEYS.shellCommand, 'sudo lcp_cli set channel ' + value);
    const url =
      BACKEND_METHOD_CONSTANT.sensor + BACKEND_METHOD_TYPES.remoteCommand;

    return this.post(url, httpParams, sensorId)
      .pipe(
        map((newsensor: SensorModel) => {
          return newsensor ? newsensor : undefined;
        })
      )
      .catch(this.handleError);
  }

  // tslint:disable-next-line: max-line-length
  setLandingPage(
    sensorId: number,
    domainName?: string,
    siteId?: number,
    userName?: string,
    pw?: string,
  ): Observable<SensorRemoteCommandModel> {
    const c1 = 'sudo lcp_cli set redirect_url ';
    // tslint:disable-next-line: max-line-length
    const c2 =
      encodeURIComponent(domainName) +
      encodeURIComponent('/?user=') +
      userName +
      encodeURIComponent('&pass=') +
      pw +
      encodeURIComponent("&visitorId={{clientmaclong}}&siteId=") +
      siteId;

    const httpParams = new HttpParams()
      .set(BACKEND_KEYS.user, this.authService.user.username)
      .set(BACKEND_KEYS.pass, this.authService.user.password)
      .set(BACKEND_KEYS.sensorId, sensorId.toString())
      // tslint:disable-next-line: max-line-length
      .set(BACKEND_KEYS.shellCommand, c1 + c2);
    const url =
      BACKEND_METHOD_CONSTANT.sensor + BACKEND_METHOD_TYPES.remoteCommand;

    return this.post(url, httpParams)
      .pipe(
        map((newsensor: SensorRemoteCommandModel) => {
          return newsensor ? newsensor : undefined;
        }),
      )
      .catch(this.handleError);
  }

  setInternetAccess(
    sensorId: number,
    access: string,
  ): Observable<SensorRemoteCommandModel> {
    const httpParams = new HttpParams()
      .set(BACKEND_KEYS.user, this.authService.user.username)
      .set(BACKEND_KEYS.pass, this.authService.user.password)
      .set(BACKEND_KEYS.sensorId, sensorId.toString())
      // tslint:disable-next-line: max-line-length
      .set(
        BACKEND_KEYS.shellCommand,
        "sudo sed -is 's/^\\(block_internet\\s*=\\s*).*$/\\1" +
          JSON.stringify(access) +
          "/' s/etc/nodogsplash/lba-captiveportal.conf"
      );
    const url =
      BACKEND_METHOD_CONSTANT.sensor + BACKEND_METHOD_TYPES.remoteCommand;

    return this.post(url, httpParams)
      .pipe(
        map((newsensor: SensorRemoteCommandModel) => {
          return newsensor ? newsensor : undefined;
        })
      )
      .catch(this.handleError);
  }

  setEncryption(
    sensorId: number,
    enc: string,
    pw?: string,
  ): Observable<SensorRemoteCommandModel> {
    if (enc === 'wpa2') {
      const httpParams = new HttpParams()
        .set(BACKEND_KEYS.user, this.authService.user.username)
        .set(BACKEND_KEYS.pass, this.authService.user.password)
        .set(BACKEND_KEYS.sensorId, sensorId.toString())
        // tslint:disable-next-line: max-line-length
        .set(
          BACKEND_KEYS.shellCommand,
          'sudo wifi-ap.config set wifi.security-passphrase="' +
            JSON.stringify(pw) +
            '" && sudo wifi-ap.config set wifi.security="' +
            JSON.stringify(enc) +
            '"',
        );
      const url =
        BACKEND_METHOD_CONSTANT.sensor + BACKEND_METHOD_TYPES.remoteCommand;

      return this.post(url, httpParams)
        .pipe(
          map((newsensor: SensorRemoteCommandModel) => {
            return newsensor ? newsensor : undefined;
          }),
        )
        .catch(this.handleError);
    } else if (enc === 'open') {
      const httpParams = new HttpParams()
        .set(BACKEND_KEYS.user, this.authService.user.username)
        .set(BACKEND_KEYS.pass, this.authService.user.password)
        .set(BACKEND_KEYS.sensorId, sensorId.toString())
        // tslint:disable-next-line: max-line-length
        .set(
          BACKEND_KEYS.shellCommand,
          'sudo wifi-ap.config set wifi.security="' + JSON.stringify(enc) + '"',
        );
      const url =
        BACKEND_METHOD_CONSTANT.sensor + BACKEND_METHOD_TYPES.remoteCommand;

      return this.post(url, httpParams)
        .pipe(
          map((newsensor: SensorRemoteCommandModel) => {
            return newsensor ? newsensor : undefined;
          })
        )
        .catch(this.handleError);
    }
  }

  setInterface(
    sensorId: number,
    intf: string,
  ): Observable<SensorRemoteCommandModel> {
    if (intf === 'lan') {
      const httpParams = new HttpParams()
        .set(BACKEND_KEYS.user, this.authService.user.username)
        .set(BACKEND_KEYS.pass, this.authService.user.password)
        .set(BACKEND_KEYS.sensorId, sensorId.toString())
        // tslint:disable-next-line: max-line-length
        .set(
          BACKEND_KEYS.shellCommand,
          'sudo wifi-ap.config set share.network-interface="eth0"',
        );

      const url =
        BACKEND_METHOD_CONSTANT.sensor + BACKEND_METHOD_TYPES.remoteCommand;

      return this.post(url, httpParams)
        .pipe(
          map((newsensor: SensorRemoteCommandModel) => {
            return newsensor ? newsensor : undefined;
          })
        )
        .catch(this.handleError);
    } else if (intf === 'lte') {
      const httpParams = new HttpParams()
        .set(BACKEND_KEYS.user, this.authService.user.username)
        .set(BACKEND_KEYS.pass, this.authService.user.password)
        .set(BACKEND_KEYS.sensorId, sensorId.toString())
        // tslint:disable-next-line: max-line-length
        .set(
          BACKEND_KEYS.shellCommand,
          'sudo wifi-ap.config set share.network0interface="ppp0"',
        );

      const url =
        BACKEND_METHOD_CONSTANT.sensor + BACKEND_METHOD_TYPES.remoteCommand;

      return this.post(url, httpParams)
        .pipe(
          map((newsensor: SensorRemoteCommandModel) => {
            return newsensor ? newsensor : undefined;
          })
        )
        .catch(this.handleError);
    }
  }

  getNotExecutedSensor(
    sensorId?: SensorModel,
  ): Observable<SensorRemoteCommandModel> {
    let httpParams = this.getBaseHttpParamsRemoteExecutedSensor();
    if (sensorId !== null && sensorId !== undefined) {
      httpParams = httpParams.set(BACKEND_KEYS.sensorId, String(sensorId));
    }

    const url =
      BACKEND_METHOD_CONSTANT.sensor + BACKEND_METHOD_TYPES.remoteCommand;

    return this.get(url, httpParams)
      .pipe(
        map((sensor: any) => {
          return sensor ? sensor : undefined;
        })
      )
      .catch(this.handleError);
  }

  getExecutedSensor(
    sensorId?: SensorModel,
  ): Observable<SensorRemoteCommandModel> {
    let httpParams = new HttpParams()
      .set(BACKEND_KEYS.user, this.authService.user.username)
      .set(BACKEND_KEYS.pass, this.authService.user.password)
      .set(BACKEND_KEYS.executed, 'true')
      .set(BACKEND_KEYS.Page, '0')
      .set(BACKEND_KEYS.Size, '99999')
      .set(BACKEND_KEYS.Sort, 'id,desc');

    if (sensorId !== null && sensorId !== undefined) {
      httpParams = httpParams.set(BACKEND_KEYS.sensorId, String(sensorId));
    }

    const url =
      BACKEND_METHOD_CONSTANT.sensor + BACKEND_METHOD_TYPES.remoteCommand;

    return this.get(url, httpParams)
      .pipe(
        map((sensor: any) => {
          return sensor ? sensor : undefined;
        })
      )
      .catch(this.handleError);
  }

  deleteRemoteCommand(remoteCommandId: number): Observable<SensorModel> {
    let httpParams = new HttpParams()
      .set(BACKEND_KEYS.user, this.authService.user.username)
      .set(BACKEND_KEYS.pass, this.authService.user.password)
      .set(BACKEND_KEYS.executed, "true");

    if (remoteCommandId !== null && remoteCommandId !== undefined) {
      httpParams = httpParams.set(
        BACKEND_KEYS.remoteCommandId,
        String(remoteCommandId)
      );
    }

    const url =
      BACKEND_METHOD_CONSTANT.sensor + BACKEND_METHOD_TYPES.remoteCommand;

    return this.deleteMasterServer(url, httpParams)
      .pipe(
        map((res) => {
          return res ? res : undefined;
        })
      )
      .catch(this.handleError);
  }

  updateSensor(sensor: SensorModel): Observable<SensorModel> {
    const httpParams = this.getBaseHttpParams();

    const url = BACKEND_METHOD_CONSTANT.sensor + BACKEND_METHOD_TYPES.update;

    return this.put(url, httpParams, sensor)
      .pipe(
        map((object: SensorModel) => {
          // console.log(reg);
          return object ? object : undefined;
        })
      )
      .catch(this.handleError);
  }

  getSensor(sensorId: number): Observable<SensorModel> {
    const httpParams = this.getBaseHttpParams().set(
      BACKEND_KEYS.sensorId,
      sensorId.toString()
    );

    const url = BACKEND_METHOD_CONSTANT.sensor + BACKEND_METHOD_TYPES.get;

    return this.get(url, httpParams)
      .pipe(
        map((sensor: SensorModel) => {
          return sensor ? sensor : undefined;
        })
      )
      .catch(this.handleError);
  }

  getSensorPassword(sensorId: number): Observable<SensorModel> {
    const httpParams = this.getBaseHttpParamsWithoutPlatform().set(
      BACKEND_KEYS.sensorId,
      sensorId.toString()
    );

    const url =
      BACKEND_METHOD_CONSTANT.sensorPassword + BACKEND_METHOD_TYPES.get;

    return this.get(url, httpParams)
      .pipe(
        map((sensor: SensorModel) => {
          return sensor ? sensor : undefined;
        })
      )
      .catch(this.handleError);
  }

  // https://master.lbasense.com/ListSensorsPerSite?pass=%21maksim1&platformId=7&siteId=225&user=maksim

  getSensorsPerSite(siteId?: number): Observable<SensorModel[]> {
    let httpParams = this.getBaseHttpParams();

    if (siteId !== null && siteId !== undefined) {
      httpParams = httpParams.set(BACKEND_KEYS.siteId, String(siteId));
    }

    const url = BACKEND_METHOD_CONSTANT.sensorPerSite;

    return this.get(url, httpParams)
      .pipe(
        map((sensors: SensorModel[]) => {
          return sensors ? sensors : undefined;
        })
      )
      .catch(this.handleError);
  }

  getSensors(
    siteId?: number,
    serverId?: number,
    type?: string
  ): Observable<SensorModel[]> {
    let httpParams = this.getBaseHttpParams();

    if (siteId !== null && siteId !== undefined) {
      httpParams = httpParams.set(BACKEND_KEYS.siteId, String(siteId));
    }

    if (serverId !== null && serverId !== undefined) {
      httpParams = httpParams.set(BACKEND_KEYS.serverId, String(serverId));
    }

    if (type !== null && type !== undefined) {
      httpParams = httpParams.set(BACKEND_KEYS.type, String(type));
    }

    const url = BACKEND_METHOD_CONSTANT.sensor + BACKEND_METHOD_TYPES.list;

    return this.get(url, httpParams)
      .pipe(
        map((sensors: SensorModel[]) => {
          // console.log(sensors);
          return sensors ? sensors : undefined;
        })
      )
      .catch(this.handleError);
  }

  getSensorMessages(
    sensorId: number,
    startTime: string,
    endTime: string,
    limit?: number,
    startIndex?: number
  ): Observable<SensorMessageModel[]> {
    let httpParams = this.getBaseHttpParams();

    httpParams = httpParams.set(BACKEND_KEYS.sensorId, String(sensorId));
    httpParams = httpParams.set(BACKEND_KEYS.startTime, startTime);
    httpParams = httpParams.set(BACKEND_KEYS.endTime, endTime);
    if (limit != null) {
      httpParams = httpParams.set(BACKEND_KEYS.limit, String(limit));
    }
    if (startIndex != null) {
      httpParams = httpParams.set(BACKEND_KEYS.startIndex, String(startIndex));
    }

    const url =
      BACKEND_METHOD_CONSTANT.sensor +
      "/" +
      BACKEND_METHOD_CONSTANT.statusMessages;

    return this.get(url, httpParams)
      .pipe(
        map((objects: any) => {
          return objects ? objects : undefined;
        })
      )
      .catch(this.handleError);
  }

  getSensorReports(
    sensorId: number,
    startTime: string,
    endTime: string,
    limit?: number,
    startIndex?: number
  ): Observable<SensorReportModel[]> {
    let httpParams = this.getBaseHttpParams();
    httpParams = httpParams.set(BACKEND_KEYS.sensorId, String(sensorId));
    httpParams = httpParams.set(BACKEND_KEYS.startTime, startTime);
    httpParams = httpParams.set(BACKEND_KEYS.endTime, endTime);

    if (limit != null) {
      httpParams = httpParams.set(BACKEND_KEYS.limit, String(limit));
    }

    if (startIndex != null) {
      httpParams = httpParams.set(BACKEND_KEYS.startIndex, String(startIndex));
    }

    const url =
      BACKEND_METHOD_CONSTANT.sensor +
      "/" +
      BACKEND_METHOD_CONSTANT.statusReports;

    return this.get(url, httpParams)
      .pipe(
        map((objects: SensorReportModel[]) => {
          return objects ? objects : undefined;
        })
      )
      .catch(this.handleError);
  }

    getSensorStatus(
    sensorId: number,
    startTime: string,
    endTime: string,
  ): Observable<any> {
    let httpParams = this.getBaseHttpParams();
    httpParams = httpParams.set(BACKEND_KEYS.sensorId, String(sensorId));
    httpParams = httpParams.set(BACKEND_KEYS.startTime, startTime);
    httpParams = httpParams.set(BACKEND_KEYS.endTime, endTime);
    httpParams = httpParams.set(BACKEND_KEYS.resolution, 'minutes');

    const url =
      BACKEND_METHOD_CONSTANT.sensorStatusReports;

    return this.get(url, httpParams)
      .pipe(
        map((objects: any) => {
          return objects ? objects : undefined;
        })
      )
      .catch(this.handleError);
  }

  getHardwareList(): Observable<BaseModel[]> {
    const httpParams = this.getBaseHttpParams();

    const url = BACKEND_METHOD_CONSTANT.hardwareList;

    return this.get(url, httpParams)
      .pipe(
        map((hardwareList: BaseModel[]) => {
          // console.log(hardwareList);
          return hardwareList ? hardwareList : undefined;
        })
      )
      .catch(this.handleError);
  }

  associateSensor(
    sensorId: number,
    regionId: number,
    siteId: number
  ): Observable<any> {
    const httpParams = this.getBaseHttpParams()
      .set(BACKEND_KEYS.sensorId, sensorId.toString())
      .set(BACKEND_KEYS.siteId, String(siteId))
      .set(BACKEND_KEYS.regionId, regionId.toString());

    //    @weakify(self);

    const url =
      BACKEND_METHOD_CONSTANT.sensor +
      "/" +
      BACKEND_METHOD_CONSTANT.associateWithSite;

    return this.post(url, httpParams)
      .pipe(
        map((response: any) => {
          return response ? response : undefined;
        })
      )
      .catch(this.handleError);
  }

  disassociateSensor(sensorId: number, siteId: number): Observable<any> {
    const httpParams = this.getBaseHttpParams()
      .set(BACKEND_KEYS.sensorId, sensorId.toString())
      .set(BACKEND_KEYS.siteId, String(siteId));

    //    @weakify(self);

    const url =
      BACKEND_METHOD_CONSTANT.sensor +
      "/" +
      BACKEND_METHOD_CONSTANT.disassociateFromSite;

    return this.post(url, httpParams)
      .pipe(
        map((response: any) => {
          return response ? response : undefined;
        })
      )
      .catch(this.handleError);
  }

  // https://master.lbasense.com/Sensor/DropInitialized?user=adminservice&pass=UNZd5zNG5NKTXh8CbfB3qnVfa&sensorId=1107

  resetInitializedSensor(sensorId: number): Observable<any> {
    const httpParams = this.getBaseHttpParams().set(
      BACKEND_KEYS.sensorId,
      sensorId.toString()
    );

    //    @weakify(self);

    const url =
      BACKEND_METHOD_CONSTANT.sensor +
      "/" +
      BACKEND_METHOD_CONSTANT.dropInitialized;

    return this.put(url, httpParams)
      .pipe(
        map((response: any) => {
          return response ? response : undefined;
        })
      )
      .catch(this.handleError);
  }

  getGSMSensorReport(
    startTime: string,
    endTime: string,
    sensorId: number
  ): Observable<GsmSensorReportModel[]> {
    let httpParams = this.getBaseHttpParamsWithoutPlatform();

    httpParams = httpParams.set(BACKEND_KEYS.startTime, startTime);

    httpParams = httpParams.set(BACKEND_KEYS.endTime, endTime);

    httpParams = httpParams.set(BACKEND_KEYS.sensorId, String(sensorId));

    const url =
      BACKEND_METHOD_CONSTANT.gsmStatusReports + BACKEND_METHOD_TYPES.list;

    return this.get(url, httpParams)
      .pipe(
        map((objects: GsmSensorReportModel[]) => {
          // console.log('log: ', logs[0])
          return objects ? objects : undefined;
        })
      )
      .catch(this.handleError);
  }

  getBTSReport(
    startTime: string,
    endTime: string,
    sensorId: number
  ): Observable<BtsModel[]> {
    let httpParams = this.getBaseHttpParamsWithoutPlatform();

    httpParams = httpParams.set(BACKEND_KEYS.startTime, startTime);

    httpParams = httpParams.set(BACKEND_KEYS.endTime, endTime);

    httpParams = httpParams.set(BACKEND_KEYS.sensorId, String(sensorId));

    const url = BACKEND_METHOD_CONSTANT.btsReports + BACKEND_METHOD_TYPES.list;

    return this.get(url, httpParams)
      .pipe(
        map((objects: BtsModel[]) => {
          // console.log('log: ', logs[0])
          return objects ? objects : undefined;
        })
      )
      .catch(this.handleError);
  }

  getSensorFromId(sensorId: number, sensors: SensorModel[]): SensorModel {
    for (const sensor of sensors) {
      if (sensorId === sensor.id) {
        return sensor;
      }
    }
    return null;
  }

  getGsmSensor(siteId: number): Observable<GsmSensorModel[]> {
    let httpParams = this.getBaseHttpParams();

    if (siteId !== null && siteId !== undefined) {
      httpParams = httpParams.set(BACKEND_KEYS.siteId, String(siteId));
    }

    const url = BACKEND_METHOD_CONSTANT.gsm + BACKEND_METHOD_TYPES.list;

    return this.get(url, httpParams)
      .pipe(
        map((sensors: GsmSensorModel[]) => {
          // console.log(sensors);
          return sensors ? sensors : undefined;
        })
      )
      .catch(this.handleError);
  }

  updateGsmSensor(sensor: GsmSensorModel): Observable<GsmSensorModel> {
    const httpParams = this.getBaseHttpParams();

    const url = BACKEND_METHOD_CONSTANT.gsm + BACKEND_METHOD_TYPES.update;

    return this.put(url, httpParams, sensor)
      .pipe(
        map((newSensor: GsmSensorModel) => {
          // console.log(newsite);
          return newSensor ? newSensor : undefined;
        })
      )
      .catch(this.handleError);
  }

  getGsmSensorConfiguration(
    sensorId: number
  ): Observable<GsmConfigurationModel> {
    let httpParams = this.getBaseHttpParams();

    if (sensorId !== null && sensorId !== undefined) {
      httpParams = httpParams.set(BACKEND_KEYS.sensorId, String(sensorId));
    }

    const url =
      BACKEND_METHOD_CONSTANT.sensorGsmConfiguration + BACKEND_METHOD_TYPES.get;

    return this.get(url, httpParams)
      .pipe(
        map((sensors: GsmConfigurationModel) => {
          // console.log(sensors);
          return sensors ? sensors : undefined;
        })
      )
      .catch(this.handleError);
  }

  updateGsmSensorConfiguration(
    gsmSensor: GsmConfigurationModel
  ): Observable<GsmConfigurationModel> {
    const httpParams = this.getBaseHttpParams();

    const url =
      BACKEND_METHOD_CONSTANT.sensorGsmConfiguration +
      BACKEND_METHOD_TYPES.update;

    return this.put(url, httpParams, gsmSensor)
      .pipe(
        map((updatedGsm: GsmConfigurationModel) => {
          // console.log(gsmSensor);
          return updatedGsm ? updatedGsm : undefined;
        })
      )
      .catch(this.handleError);
  }

  getDistributorSensors(userId: number): Observable<DistributorSensorModel[]> {
    const httpHeaders = this.authHeader(
      this.authService.user.username,
      this.authService.user.password
    );
    const httpParams = new HttpParams().set(
      BACKEND_KEYS.userId,
      String(userId)
    );
    const url =
      BACKEND_METHOD_CONSTANT.distributor + BACKEND_METHOD_TYPES.sensors;

    return this.getMaster(url, httpParams, httpHeaders)
      .pipe(
        map((sensors: DistributorSensorModel[]) => {
          return sensors ? sensors : undefined;
        })
      )
      .catch(this.handleError);
  }

  disAssociateSensorFromDistributor(userId, sensorId): Observable<any> {
    const httpHeaders = this.authHeader(
      this.authService.user.username,
      this.authService.user.password
    );

    let httpParams = this.getBaseHttpParamsWithoutPlatform();

    httpParams = httpParams.set(BACKEND_KEYS.userId, String(userId));
    httpParams = httpParams.set(BACKEND_KEYS.sensorId, String(sensorId));

    const url =
      BACKEND_METHOD_CONSTANT.distributor + BACKEND_METHOD_TYPES.sensors;

    return this.deleteMasterServer(url, httpParams, httpHeaders)
      .pipe(
        map((res) => {
          return res ? res : undefined;
        })
      )
      .catch(this.handleError);
  }

  associateSensorFromDistributor(relation): Observable<any> {
    const httpHeaders = this.authHeader(
      this.authService.user.username,
      this.authService.user.password
    );

    const url =
      BACKEND_METHOD_CONSTANT.distributor + BACKEND_METHOD_TYPES.sensors;

    return this.masterServerPost(url, null, relation, httpHeaders)
      .pipe(
        map((res) => {
          return res ? res : undefined;
        })
      )
      .catch(this.handleError);
  }
}
